import type { SelectOption } from '../Select'

/** A loaded option is the `{ _id, code, name }` tenant plus the `value` and `label` that `SelectAsync` adds. */
export const getTenantOptionLabel = (tenant: SelectOption) => `${tenant.name} (${tenant.code})`

/** `getTenantOptions` takes only `{ search }`; the server builds the name/code match, so the client sends no regex. */
export const buildTenantFilter = ({ input }: { input: unknown }) => ({ search: input })
